const DefaultContainer = () => import('@/containers/DefaultContainer');

const Companies = () => import('./');
const Add = () => import('./components/Add');
const VerificationQueue = () => import('./components/VerificationQueue');
const Edit = () => import('./components/Edit');
const DetailsTab = () => import('./components/Edit/Tabs/Details');

const GridTest = () => import('./components/GridTest');

const companyRoute = {
  path: '/companies',
  component: DefaultContainer,
  children: [
    {
      path: 'grid-test',
      component: GridTest
    },
    {
      path: '',
      component: Companies
    },
    {
      path: 'add',
      name: 'companies.add',
      meta: { label: 'Add' },
      component: Add,
    },
    {
      path: 'verify',
      name: 'companies.verify',
      meta: { label: 'Verify' },
      component: VerificationQueue,
    },
    {
      path: ':id',
      name: 'companies.edit',
      meta: { label: 'Edit' },
      component: Edit,
      // children: [
      //   {
      //     path: '',
      //     redirect: 'details',
      //   },
      //   {
      //     path: 'details',
      //     name: 'company.details',
      //     meta: { label: 'Details' },
      //     component: DetailsTab,
      //   }
      // ]
    },
  ]
};

export default companyRoute;
